import { render, staticRenderFns } from "./DragAndDropUploadCard.vue?vue&type=template&id=d59d2656&scoped=true&"
import script from "./DragAndDropUploadCard.vue?vue&type=script&lang=js&"
export * from "./DragAndDropUploadCard.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropUploadCard.vue?vue&type=style&index=0&id=d59d2656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59d2656",
  null
  
)

export default component.exports